import type { DomainMapper } from '../types';

import at from './at';
import dk from './dk';
import fi from './fi';
import fr from './fr';
import gb from './gb';
import global from './global';
import no from './no';
import se from './se';
import us from './us';
import de from './de';
import corporateEn from './corporate-en';
import corporateSe from './corporate-se';

const localDomains: DomainMapper[] = [gb, de, at, fr, us, se, no, fi, dk, global, corporateEn, corporateSe];

export default localDomains;
